import Image from 'next/image';
import Icon from './hamburger_white.svg?url';
import type { SvgImageProps } from '../_type';

export const HamburgerWhiteImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={Icon} alt={alt} {...props} />;
